<template>
	<div class="panel-group">
		<slot></slot>
	</div>
</template>

<script>
/* eslint-disable */
export default {
	name: 'accordion',
	description: 'It can be used with panel component.',
	props: {
		oneAtAtime: {
			type: Boolean,
			default: false,
			note: "Open one accordion at once, no multiple open allowed"
		}
	},
	methods: {
		open(child) {
			if (this.oneAtAtime) {
				this.$children.forEach(item => {
					if (child !== item) {
						item.open = false;
					}
				});
			}
		}
	},
	created() {
		this.accordion = true;
	}
};
</script>
